/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component} from '@angular/core';
import {Items} from './providers/items';
import {Page} from './providers/page';
export class DatagridPlaceholder {
/**
 * @param {?} items
 * @param {?} page
 */
constructor(private items: Items,
private page: Page) {}
/**
 * Tests if the datagrid is empty, meaning it doesn't contain any items
 * @return {?}
 */
public get emptyDatagrid() {
        return !this.items.loading && (!this.items.displayed || this.items.displayed.length === 0);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-placeholder",
    template: `
        <div
            class="datagrid-placeholder"
            [class.datagrid-empty]="emptyDatagrid">
                <div class="datagrid-placeholder-image" *ngIf="emptyDatagrid"></div>
                <ng-content *ngIf="emptyDatagrid"></ng-content>
        </div>
    `,
    host: {"[class.datagrid-placeholder-container]": "true"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Items, },
{type: Page, },
];
}

function DatagridPlaceholder_tsickle_Closure_declarations() {
/** @type {?} */
DatagridPlaceholder.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridPlaceholder.ctorParameters;
/** @type {?} */
DatagridPlaceholder.prototype.items;
/** @type {?} */
DatagridPlaceholder.prototype.page;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
